'use client'

// src/components/bullets/patterns.ts
var LENGTH_8_PATTERN = /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/;
var ONE_LETTER_PATTERN = /^(?=.*[a-zA-Z])/;
var ONE_NUMBER_PATTERN = /^(?=.*\d)/;

export {
  LENGTH_8_PATTERN,
  ONE_LETTER_PATTERN,
  ONE_NUMBER_PATTERN
};
//# sourceMappingURL=chunk-V6OLRYZ6.mjs.map